import { Box, Stack, Text } from '@chakra-ui/react'
import { formatDate } from 'modules/EpidDashboard/formatDate'
import { colorScale, parseDate } from 'modules/EpidDashboard/helpers'

type PeakBoxProps = {
  peak: {
    date: string
    value: number
    diseaseName: string
    numOfTests: number
    name: string
    relativeDays: number
    isReference: boolean
  }
  layout: 'before' | 'after'
}

const PeakBox = ({ peak, layout }: PeakBoxProps) => {
  const dateLabel = (
    <Text fontSize='xs' color={colorScale(peak.diseaseName)}>
      {formatDate(parseDate(peak.date))}
    </Text>
  )

  const diseaseBox = (
    <Box
      py={`calc(var(--chakra-space-2) + ${peak.isReference ? 0 : 3}px)`}
      px={`calc(var(--chakra-space-3) + ${peak.isReference ? 0 : 3}px)`}
      bg={colorScale(peak.diseaseName)}
      color='white'
      rounded='md'
      textAlign='center'
      minW='80px'
      border={peak.isReference ? '3px solid' : ''}
      borderColor={peak.isReference ? 'red.500' : 'transparent'}
      position='relative'
      overflow='hidden'
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: `${Math.min(parseFloat(peak.value.toString()), 100)}%`,
        height: '100%',
        bg: 'rgba(0, 0, 0, 0.3)',
        borderLeftRadius: 'md',
        zIndex: 1,
      }}
    >
      <Text fontSize='xs' fontWeight='bold' position='relative' zIndex={2}>
        {peak.diseaseName}
      </Text>
      <Text fontSize='xs' fontWeight='bold' position='relative' zIndex={2}>
        {parseFloat(peak.value.toString()).toFixed(2)}%
      </Text>
    </Box>
  )

  const relativeDaysLabel = (
    <Box
      bg={'yellow.400'}
      color={'black'}
      px={2}
      py={1}
      rounded='md'
      fontSize='xs'
      fontWeight='bold'
    >
      {peak.isReference
        ? 'Week 0'
        : layout === 'after'
          ? `+${Math.round(peak.relativeDays / 7)} weeks`
          : `${Math.round(peak.relativeDays / 7)} weeks`}
    </Box>
  )

  return (
    <Stack key={`${peak.diseaseName}-${peak.date}`} spacing={1} align='center'>
      {layout === 'before' ? (
        <>
          {dateLabel}
          {diseaseBox}
          {relativeDaysLabel}
        </>
      ) : (
        <>
          {relativeDaysLabel}
          {diseaseBox}
          {dateLabel}
        </>
      )}
    </Stack>
  )
}

export default PeakBox
